export const FETCH_NISAB = "FETCH_NISAB";
export const FETCH_ZAKAT = "FETCH_ZAKAT";
export const UPDATE_ZAKAT = "UPDATE_ZAKAT";
export const CREATE_ZAKAT_ASSET = "CREATE_ZAKAT_ASSET";
export const UPDATE_ZAKAT_ASSET = "UPDATE_ZAKAT_ASSET";
export const DELETE_ZAKAT_ASSET = "DELETE_ZAKAT_ASSET";
export const CREATE_ZAKAT_LIABILITY = "CREATE_ZAKAT_LIABILITY";
export const UPDATE_ZAKAT_LIABILITY = "UPDATE_ZAKAT_LIABILITY";
export const DELETE_ZAKAT_LIABILITY = "DELETE_ZAKAT_LIABILITY";

// Draft zakat actions (FF_ZAKAT_2026)
export const FETCH_DRAFT_ZAKAT = "FETCH_DRAFT_ZAKAT";
export const CREATE_DRAFT_ZAKAT = "CREATE_DRAFT_ZAKAT";
export const UPDATE_DRAFT_ZAKAT = "UPDATE_DRAFT_ZAKAT";
export const CLONE_LATEST_ZAKAT = "CLONE_LATEST_ZAKAT";

// Zakat history
export const FETCH_ALL_ZAKATS = "FETCH_ALL_ZAKATS";

// no api calls for these
export const UPDATE_ZAKAT_TOP_UP = "UPDATE_ZAKAT_TOP_UP";
export const UPDATE_ZAKAT_PAYMENT_AMOUNT = "UPDATE_ZAKAT_PAYMENT_AMOUNT";
